// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ConciergeService from '../_raw/service/icon_concierge_service.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ConciergeService);
